import Unsubscribe from "../components/Unsubscribe";
import { Grid } from "@mui/material";
import translations from "../translations/french.json";
import Wrapper from "../components/Wrapper";

const UnsubscribeFr = () => {
  return (
    <Wrapper lang="fr">
      <Grid container alignItems="center" justifyContent="center">
        <Unsubscribe translations={translations.unsubscribe} lang="fr" />
      </Grid>
    </Wrapper>
  );
};

export default UnsubscribeFr;
